import { gql } from '@generated/gql';

export const PostQuery = gql(/* GraphQL */ `
  query PostQuery(
    $path: String!
    $language: LanguageId!
    $translate: LanguageId!
  ) {
    route: route(path: $path) {
      ... on EntityCanonicalUrl {
        entity {
          ...PostContentFragment
        }
      }
    }

    ads: nodeQuery(
      filter: {
        conditions: [
          { field: "type", value: "ad", language: $language }
          { field: "status", value: ["1"] }
        ]
      }
      sort: [{ field: "nid", direction: DESC }]
    ) {
      ...AdsFragment
    }

    termIssue: blockContentQuery(
      filter: {
        conjunction: AND
        conditions: [
          { field: "type", value: "translations", language: $language }
          { field: "info", value: "Issue" }
        ]
      }
    ) {
      translation: entities {
        value: entityTranslation(language: $language) {
          ... on BlockContentTranslations {
            text: fieldPlaintext
          }
        }
      }
    }

    termPrint: blockContentQuery(
      filter: {
        conjunction: AND
        conditions: [
          { field: "type", value: "translations", language: $language }
          { field: "info", value: "Print" }
        ]
      }
    ) {
      translation: entities {
        value: entityTranslation(language: $language) {
          ... on BlockContentTranslations {
            text: fieldPlaintext
          }
        }
      }
    }
    termMoreContributions: blockContentQuery(
      filter: {
        conjunction: AND
        conditions: [
          { field: "type", value: "translations", language: $language }
          { field: "info", value: "More contributions" }
        ]
      }
    ) {
      translation: entities {
        value: entityTranslation(language: $language) {
          ... on BlockContentTranslations {
            text: fieldPlaintext
          }
        }
      }
    }

    ...LayoutFragment
    ...TermLoginFormFragment
    ...TermTocFragment
  }
`);

export const RelatedPostsQuery = gql(/* GraphQL */ `
  query RelatedPostsQuery(
    $path: String!
    $language: LanguageId!
    $categories: [String]
    $tags: [String]
    $dateline: [String]
  ) {
    route(path: $path) {
      ... on EntityCanonicalUrl {
        entity {
          ...RelatedPostsFragment
        }
      }
    }
  }
`);

export const RelatedPostsFragment = gql(/* GraphQL */ `
  fragment RelatedPostsFragment on NodePost {
    entityQueryExclusive(
      filter: {
        conjunction: AND
        conditions: [
          { field: "field_category", value: $categories }
          { field: "status", value: "1" }
          { field: "field_tags", value: $tags }
          { field: "field_dateline", value: $dateline }
        ]
      }
      sort: [
        { field: "field_date.value", direction: DESC }
        { field: "nid", direction: DESC }
      ]
      limit: 20
    ) {
      entities {
        value: entityTranslation(language: $language) {
          ...PostTeaserFragment
        }
      }
    }
  }
`);
